import React from 'react';

function Contact() {
  return (
    <div>
      talk 2 me @ <a href="mailto:linsey@example.com">linsey@example.com</a>
    </div>
  )
}

export default Contact;